import React, { Component } from "react";

export default class FlyingDroneImg extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <svg
        width="834.73187"
        height="525.85234"
        viewBox="0 0 834.73187 525.85234"
      >
        <g>
          <path
            id="uuid-9355c850-1a87-4a07-99bb-80cbbe234fdd-95-162-101-681-285"
            d="m450.99826,300.08365c11.48846-4.0777,22.90482-1.45526,25.49866,5.85651,2.59387,7.31177-4.61652,16.54236-16.10965,20.61996-4.56866,1.6918-9.4761,2.26492-14.31165,1.67133l-48.89529,16.66263-7.3302-23.11179,48.98032-13.97266c3.38071-3.51013,7.55307-6.15939,12.16779-7.72598h.00003Z"
            fill="#ffb4b4"
          />
          <path
            d="m433.21136,334.68762l-96.50128,44.76727-.24185.11243-78.4631-47.90979c-7.24582-4.42493-11.6499-12.13483-11.78099-20.62524-.13002-8.49023,4.03593-16.33209,11.14409-20.9769,8.90469-5.81842,20.47754-5.27423,28.79697,1.35425l57.8544,46.09921,81.992-30.10461,7.19974,27.28342.00003-.00003Z"
            fill="#e4e4e4"
          />
        </g>
        <path
          d="m0,485.79529c0,.66003.53003,1.19,1.19006,1.19h786.28998c.65997,0,1.19-.52997,1.19-1.19,0-.65997-.53003-1.19-1.19-1.19H1.19006c-.66003,0-1.19006.53003-1.19006,1.19Z"
          fill="#3f3d56"
        />
        <g>
          <polygon
            points="309.05228 299.89322 315.51895 259.4765 271.8689 241.69315 265.40225 303.12656 309.05228 299.89322"
            fill="#ffb4b4"
          />
          <circle cx="298.02158" cy="227.95637" r="44.51263" fill="#ffb4b4" />
        </g>
        <g>
          <path
            d="m253.83723,517.83984c2.90996,1.28027,6.01997,2.5,9.36,3.66016,49.87,17.29004,107.69-20.69043,140.84998-48.07031,16.71002-13.80957,27.15002-24.92969,27.15002-24.92969l32.71997,16.36035,21.79004,10.88965h.01001l4.22998,2.12988c.01001,0,.02002.00977.02002.00977l12.88995,6.44043,19.93997,9.96973,2.40002,1.2002,1.64001.48047,29.35999,8.51953,6-21s-2.04999-1.83008-5.64001-5c-21.85999-19.25977-100.75-87.84961-121.35999-93-9.34998-2.33984-29.29999,5.33008-50.19,15.57031-32.76001,16.05957-67.81,38.42969-67.81,38.42969l-14-20-48.20001,10.87988-18.28998,4.12988-11.01001,2.49023s-34.23999,53.41016,28.14001,80.83984h.00002Z"
            fill="#2f2e41"
          />
          <path
            d="m554.1972,480.5s7-7,11-4,8,7,8,7c0,0,31,2,32,17s-21,20-21,20c0,0-72,6-72-4s10.60156-22.19922,10.60156-22.19922c0,0,34.39844-5.80078,31.39844-13.80078Z"
            fill="#2f2e41"
          />
        </g>
        <g>
          <path
            d="m253.83723,517.83984c53.8-19.76953,100.36-69.33984,100.36-69.33984l49.84998,24.92969,41.75,20.87012,2.40002,1.2002,31,9,6-21s-2.04999-1.83008-5.64001-5c-3.73999-3.29004-9.14996-8.03027-15.64001-13.63965-21.33997-18.44043-54.45996-46.37012-78.90997-63.79004-32.76001,16.05957-67.81,38.42969-67.81,38.42969l-14-20-48.20001,10.87988c-9.03998,5.44043-14.79999,9.12012-14.79999,9.12012l-3.48999-4.99023-11.01001,2.49023s-34.23999,53.41016,28.14001,80.83984h-.00002Z"
            fill="#2f2e41"
          />
          <path
            d="m477.19724,480.5s7-7,11-4,8,7,8,7c0,0,31.00003,2,32.00003,17s-21,20-21,20c0,0-72,6-72-4s10.60156-22.19922,10.60156-22.19922c0,0,34.39844-5.80078,31.39844-13.80078h-.00003Z"
            fill="#2f2e41"
          />
        </g>
        <path
          d="m230.86275,360.18262c2.15918-29.26855,14.04199-57.50684,33.45946-79.51367l.19067-.21582,50.56543,10.11328,11.06519,32.69238c7.05078,20.83301,5.37207,44.02148-4.60571,63.62012l-12.31836,24.19727,4.07202,22.39746-87.57129,4.02539-.56299.02637,5.70557-77.34277h.00002Z"
          fill="#e4e4e4"
        />
        <g>
          <path
            d="m678.82471,90.60093h36.48566v1.37559c0,9.05546-7.35187,16.40734-16.40735,16.40734h-3.67096c-9.05548,0-16.40735-7.35188-16.40735-16.40734v-1.37559h0Z"
            fill="#3f3d56"
          />
          <path
            d="m795.67798,70.54903l-62.95227-13.41594-.32764-3.66126c-.02423-.27127-.06091-.54075-.10406-.80902l29.77313-13.11113c3.06604-5.51884,8.27826-2.45282,8.27826-2.45282,0,0,10.11786,1.53301,7.97168-8.27826s-15.9433-2.75942-15.9433-2.75942l-36.17236,11.26673-5.91113-14.04052c-1.81946-4.32177-6.05194-7.13209-10.74109-7.13209h-21.04333c-4.50269,0-8.60254,2.59384-10.53113,6.66261l-6.92957,14.61959-36.52441-11.37632s-13.79712-7.05185-15.9433,2.75942,7.97168,8.27826,7.97168,8.27826c0,0,5.21222-3.06602,8.27826,2.45282l29.13458,12.82998-.57062,1.20365c-.58905,1.24288-.94812,2.57767-1.07153,3.94181l-61.10333,13.02191c-5.14392,1.09646-8.00928,6.6141-5.94702,11.45237l1.44055,3.37981c2.09302,4.91072,8.26929,6.73656,12.53784,3.53131,1.51495-1.13748,2.58435-2.79565,2.58435-5.21014l51.20007-11.91976c3.09631,13.58541,15.25073,23.72394,29.77393,23.72394h9.96069c14.74261,0,26.87299-10.39453,29.8421-24.01557l52.45337,12.21139c0,2.41449,1.06934,4.07266,2.58435,5.21014,4.26855,3.20525,10.44482,1.37941,12.53784-3.53131l1.44055-3.37981c2.06226-4.83827-.8031-10.35591-5.94708-11.45237,0,0-.00006,0-.00006,0Z"
            fill="#3f3d56"
          />
          <path
            d="m766.35962,15.41823l-30.96686-15.41823s-3.20361.13761-1.75513,1.75512c1.44849,1.61751,34.86816,17.25422,34.86816,17.25422l-2.14624-3.59111s.00006,0,.00006,0Z"
            fill={theme.imageHighlight}
          />
          <path
            d="m774.63788,21.76875s1.53302,5.82544,6.74524,9.19806,34.33942,11.65088,34.33942,11.65088l4.29242-2.75942-32.19324-17.78292-10.73108-1.22641-2.45282.91981s.00006,0,.00006,0Z"
            fill={theme.imageHighlight}
          />
          <path
            d="m795.11768,73.4544s5.7403,1.82623,11.38037-.76828,28.23383-22.75499,28.23383-22.75499l-.03058-5.10278-32.26202,17.65776-6.78424,8.40439-.53729,2.56392-.00006-.00002Z"
            fill={theme.imageHighlight}
          />
          <path
            d="m797.95203,74.17428s-4.82367-3.6081-11.00269-3.00719c-6.17908.60091-34.13574,12.23477-34.13574,12.23477l-1.6449,4.83049,36.2691-6.09823,9.16571-5.71402,1.34857-2.24582s-.00006,0-.00006,0Z"
            fill={theme.imageHighlight}
          />
          <path
            d="m630.53485,15.41823l30.9668-15.41823s3.20361.13761,1.75513,1.75512c-1.44849,1.61751-34.86816,17.25422-34.86816,17.25422,0,0,2.14624-3.59111,2.14624-3.59111Z"
            fill={theme.imageHighlight}
          />
          <path
            d="m622.25659,21.76875s-1.53302,5.82544-6.74524,9.19806-34.33942,11.65088-34.33942,11.65088l-4.29242-2.75942,32.19324-17.78292,10.73108-1.22641,2.45282.91981s-.00006,0-.00006,0Z"
            fill={theme.imageHighlight}
          />
          <path
            d="m601.77679,73.4544s-5.7403,1.82623-11.38037-.76828-28.23383-22.75499-28.23383-22.75499l.03058-5.10278,32.26202,17.65776,6.78424,8.40439.53729,2.56392.00006-.00002Z"
            fill={theme.imageHighlight}
          />
          <path
            d="m598.94238,74.17428s4.82367-3.6081,11.00269-3.00719,34.13574,12.23477,34.13574,12.23477l1.6449,4.83049-36.2691-6.09823-9.16571-5.71402-1.34857-2.24582s.00006,0,.00006,0Z"
            fill={theme.imageHighlight}
          />
          <circle cx="770.80536" cy="23.14846" r="8.58484" fill="#3f3d56" />
          <circle cx="625.01599" cy="23.91497" r="8.58484" fill="#3f3d56" />
        </g>
        <g>
          <path
            d="m431.97235,377.09985l-.81461-89.61682c-.04303-4.75262,3.15576-8.84064,7.77914-9.94141l22.29471-5.30826c2.18832-.52106,4.45636-.02182,6.22336,1.37003,1.76672,1.3916,2.78384,3.47964,2.78986,5.72873l.26663,95.96884c.00452,1.62076-.6232,3.14554-1.76761,4.29324-1.14471,1.14801-2.66766,1.78009-4.28873,1.78009h-28.16931c-2.35712,0-4.29205-1.91748-4.31342-4.27444h-.00003Z"
            fill="#2f2e41"
          />
          <path
            d="m440.10901,279.42715l2.12921-.51141v3.22098c0,1.02963.94012,1.78912,1.91968,1.55066l8.59802-2.09354c1.25293-.30515,2.13745-1.45016,2.13745-2.76755v-2.95026l4.11716-.98892c2.90543-.69794,5.69199,1.54648,5.70935,4.59891l.52905,93.07187c.02206,3.84149-3.01694,6.96756-6.77335,6.96756h-21.26285c-2.32047,0-4.20779-1.91135-4.23044-4.28424l-.81772-85.45605c-.04736-4.92819,3.25323-9.23111,7.94446-10.35797l-.00003-.00003Z"
            fill={theme.imageHighlight}
          />
        </g>
        <g>
          <path
            id="uuid-f0f0303c-5b59-4c86-93e3-26367f99a071-96-163-102-682-286"
            d="m470.04153,340.32095c11.95132-2.40378,22.87915,1.8143,24.40768,9.42047,1.52853,7.60614-6.92038,15.71848-18.87628,18.12152-4.76273,1.02542-9.70178.89536-14.4039-.37933l-50.76688,9.54544-3.97159-23.91888,50.46881-6.8707c3.84521-2.99411,8.35168-5.02359,13.14218-5.91852h-.00003Z"
            fill="#ffb4b4"
          />
          <path
            d="m274.52032,344.14938c-6.54434-5.40964-9.80789-13.66754-8.73004-22.08939,1.07758-8.42279,6.3158-15.59296,14.01157-19.18094,9.6405-4.4953,21.01785-2.31143,28.31146,5.4325l50.71664,53.85245,84.90027-18.03329.53714-.11444,3.2507,28.02988-102.13962,30.67697-70.85812-58.57373Z"
            fill="#e4e4e4"
          />
        </g>
        <path
          d="m323.92004,186.2793c8.25406,6.26785,14.06046,15.3533,15.52194,25.61389,1.07526,7.54897.05524,16.48201-6.74475,24.72098-8.93903,10.83066-10.38684,30.90491-9.9238,46.51355.28571,9.6312-8.0715,17.27817-17.64114,16.15399-20.42038-2.3989-30.45639,47.72827-45.43506,54.71832-17.2413,8.04593-32,0-32,0,0,0,5-56,16-72,6.91251-10.05453,7.87602-46.56114,9.12398-61.15613,1.33592-15.6237,9.54146-30.01952,22.75102-38.46887,12.11093-7.74663,28.69791-11.0172,48.34781,3.9043v-.00003Z"
          fill="#2f2e41"
        />
      </svg>
    );
  }
}
